import styled from "styled-components"

import { Typography } from "components/common"

const SectionTitle = styled(Typography).attrs((props) => ({
  color: "neutral",
  fontSize: { _: 16, tablet: 16 },
  letterSpacing: { _: "1px", tablet: "4px" },
  mb: 2,
  ...props,
}))``

export default SectionTitle
